import { Link } from 'react-router-dom';
import { characters } from '@/mocks/characters';

const featured = characters.slice(0, 6);

const factionColor: Record<string, string> = {
  守护者: 'bg-secondary-100 text-secondary-900',
  复活社: 'bg-accent-100 text-accent-900',
  守护甜心: 'bg-primary-100 text-primary-700',
};

export default function FeaturedCharacters() {
  return (
    <section className="w-full bg-background-100/70">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-semibold text-accent-600">
              <i className="ri-team-line" aria-hidden="true"></i>
              主要角色精选
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-900 md:text-3xl">
              守护甜心动漫主要角色
            </h2>
            <p className="mt-2 max-w-xl text-sm leading-6 text-foreground-600">
              从主角亚梦到几斗、唯世，点开卡片查看每位角色的完整背景故事与配音演员。
            </p>
          </div>
          <Link
            to="/characters"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-primary-500 px-5 py-2.5 text-sm font-semibold text-primary-600 transition-colors hover:bg-primary-500 hover:text-background-50"
          >
            全部角色
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {featured.map((c) => (
            <Link
              key={c.id}
              to={`/characters/${c.id}`}
              className="group flex flex-col overflow-hidden rounded-2xl border border-background-200/80 bg-background-50 transition-all hover:-translate-y-1 hover:border-primary-300"
            >
              <div className="relative h-64 w-full overflow-hidden bg-background-100">
                <img
                  src={c.image}
                  alt={`守护甜心动漫角色 ${c.name} 资料插画`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <span
                  className={`absolute left-3 top-3 inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ${factionColor[c.faction]}`}
                >
                  {c.faction}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-lg font-bold text-foreground-900">{c.name}</h3>
                  <span className="text-xs text-foreground-400">{c.enName}</span>
                </div>
                <p className="mt-1 text-sm font-medium text-primary-600">{c.title}</p>
                <p className="mt-3 flex-1 text-sm leading-6 text-foreground-600">{c.short}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200/80 pt-3 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-mic-line text-primary-400" aria-hidden="true"></i>
                    配音：{c.cv}
                  </span>
                  <span className="inline-flex items-center gap-1 font-semibold text-primary-600">
                    查看详情
                    <i className="ri-arrow-right-s-line transition-transform group-hover:translate-x-0.5" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}